/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { headers, setupInterceptorsTo } from "./interceptors"
import { getAWSRUMClient } from "./awsRumClient"

const { VITE_BASE_URL } = import.meta.env

class Http {
  private instance: AxiosInstance | null = null

  private get http(): AxiosInstance {
    return this.instance != null ? this.instance : this.initHttp()
  }

  initHttp() {
    const http = axios.create({
      baseURL: VITE_BASE_URL,
      headers,
      withCredentials: true,
    })

    setupInterceptorsTo(http)

    this.instance = http
    return http
  }

  private handleError = (error: any) => {
    // You can customize this to log, show a notification, or send to a monitoring service
    getAWSRUMClient()?.recordError(error)
    throw error;
  }

  request<T = any, R = AxiosResponse<T>>(
    config: AxiosRequestConfig,
  ): Promise<R> {
    return this.http.request(config)
  }

  get<T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R> {
    return this.http.get<T, R>(url, config).catch((error) => this.handleError(error))
  }

  post<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig,
  ): Promise<R> {
    return this.http.post<T, R>(url, data, config).catch((error) => this.handleError(error))
  }

  put<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig,
  ): Promise<R> {
    return this.http.put<T, R>(url, data, config).catch((error) => this.handleError(error))
  }

  patch<T = any, R = AxiosResponse<T>>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig,
  ): Promise<R> {
    return this.http.patch<T, R>(url, data, config).catch((error) => this.handleError(error))
  }

  delete<T = any, R = AxiosResponse<T>>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<R> {
    return this.http.delete<T, R>(url, config).catch((error) => this.handleError(error))
  }
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new Http()
